import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post } from '../api/client.js';

const KEY = ['clock', 'current'];

export function useCurrentShift() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => (await get('/api/clock/current')).entry || null,
    staleTime: 10_000,
  });
}

export function useClockIn() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => post('/api/clock/in', { source: 'ui', ...payload }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      // Foreman/admin's CrewRosterPanel queries crew-status and the admin
      // dashboard's "currently clocked in" list — both should reflect the
      // self-action immediately, not on the next 10s poll.
      qc.invalidateQueries({ queryKey: ['foreman', 'crew-status'] });
      qc.invalidateQueries({ queryKey: ['admin', 'dashboard'] });
      qc.invalidateQueries({ queryKey: ['live-feed'] });
    },
  });
}

export function useClockOut() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => post('/api/clock/out', { source: 'ui', ...payload }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      qc.invalidateQueries({ queryKey: ['timesheet'] });
      qc.invalidateQueries({ queryKey: ['foreman', 'crew-status'] });
      qc.invalidateQueries({ queryKey: ['admin', 'dashboard'] });
      qc.invalidateQueries({ queryKey: ['live-feed'] });
    },
  });
}
